// Drive:
{{#each interface.slavePorts}}
{{#if (or (not ../isPipelined) (eq channel ../channel))}}
//   {{ ../interface.slaveClockingBlock.name }}.{{ identifier }} <= {{#with (lookup ../sequenceItem.instanceVariablesByRelatedPort identifier )}}{{ ../../sequenceItemHandle.identifier }}.{{ identifier }}{{#if isDynamicArray}}[d]{{/if}}{{/with}};
{{/if}}
{{/each}}
